import { CustomPreloader } from '@components'
import { AccountOverviewRow } from '@dashboard'
import { useMerchantAccounts, useMyAccountAccessQry } from 'mmfintech-backend-api'

function AccountOverviewList() {
  const { accountAccess, accountAccessFetching } = useMyAccountAccessQry()

  const { activeAccounts, accountsFetching } = useMerchantAccounts()

  if (accountsFetching || accountAccessFetching) {
    return <CustomPreloader />
  }

  const accounts = activeAccounts?.map((a: any) => {
    const permission = accountAccess?.find((perm: any) => a?.id === perm?.accountId)
    return { ...a, permission: permission?.accessLevel }
  })

  return (
    <div className='mb-4'>
      {accounts.map(account => {
        return <AccountOverviewRow account={account} key={account.id} />
      })}
    </div>
  )
}

export default AccountOverviewList
